<template>
	<div v-if="show" style="">
		<div style="display: flex; margin-left: auto; margin-right: auto">
			<el-button icon="el-icon-plus" @click="$emit('add')" type="success" v-if="buttons.indexOf('add') > -1">
				{{ $t("add") }}
			</el-button>
			<el-tooltip v-if="canConfirm" placement="top">
				<div slot="content">{{ $t("confirm-email") }}</div>
				<el-button @click="$emit('confirm', true)" circle type="info">
					<md-icon style="color: white">email</md-icon>
				</el-button>
			</el-tooltip>
			<el-tooltip v-if="canConfirm" placement="top">
				<div slot="content">{{ $t("confirm-manually") }}</div>
				<el-button @click="$emit('manualconfirm', true)" circle type="info">
					<md-icon style="color: white">check</md-icon>
				</el-button>
			</el-tooltip>
			<el-tooltip v-if="buttons.indexOf('delete') > -1" placement="top">
				<div slot="content">{{ $t("delete") }}</div>
				<el-button @click="$emit('delete', true)" circle type="danger">
					<md-icon style="color: white">delete</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('archive') > -1" placement="top">
				<div slot="content">{{ $t("archive") }}</div>
				<el-button circle @click="$emit('archive', true)" type="info">
					<md-icon style="color: white">archive</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('restore') > -1" placement="bottom">
				<div slot="content">{{ $t("restore") }}</div>
				<el-button circle @click="$emit('restore', true)" type="primary">
					<md-icon style="color: white">restore</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('unblock') > -1" placement="top">
				<div slot="content">{{ $t("unblock") }}</div>
				<el-button @click="$emit('block', true)" circle>
					<md-icon style="color: white">lock_open</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('block') > -1" placement="top">
				<div slot="content">{{ $t("block") }}</div>
				<el-button @click="$emit('block', false)" circle>
					<md-icon style="color: white">lock</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('chat') > -1" placement="top">
				<div slot="content">{{ $t("chat") }}</div>
				<el-button @click="$emit('chat', true)" circle type="primary">
					<md-icon style="color: white">chat</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('clear') > -1" placement="top">
				<div slot="content">{{ $t("cancel") }}</div>
				<el-button circle @click="$emit('clear')">
					<md-icon>clear</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('save') > -1" placement="top">
				<div slot="content">{{ $t("save") }}</div>
				<el-button @click="$emit('save')" circle type="success" disabled v-if="error">
					<md-icon v-if="!saving" style="color: white">save</md-icon>
				</el-button>
				<el-button @click="$emit('save')" circle type="success" v-else>
					<md-icon v-if="!saving" style="color: white">save</md-icon>
				</el-button>
			</el-tooltip>

			<el-tooltip v-if="buttons.indexOf('open') > -1" placement="top">
				<div slot="content">{{ $t("open") }}</div>
				<md-button
					style="background-color: #90a4ae"
					class="md-icon-button md-elevation-4"
					@click="$emit('open')"
				>
					<md-icon v-if="!saving" style="color: white">open_in_new</md-icon>
					<i v-else class="el-icon-loading" style="color: white" size="2x" />
				</md-button>
			</el-tooltip>

			<el-popover v-if="buttons.indexOf('option') > -1" placement="top">
				<div slot="reference">
					<md-button class="md-icon-button">
						<md-icon>more_vert</md-icon>
					</md-button>
				</div>
				<div>
					<csv-export
						v-if="buttons.indexOf('option-csv') > -1"
						:csvEntity="csvEntity"
						:csvHeader="csvHeader"
						:csvFilters="csvFilters"
						:processCsv="processCsv"
						:csvUrl="csvUrl"
					/>
				</div>
			</el-popover>
		</div>
	</div>
</template>

<script>
import CsvExport from "@/modules/_common/button/components/csv-export.vue"

export default {
	name: "option-button",
	props: [
		"show",
		"buttons",
		"saving",
		//CSV
		"csvEntity",
		"csvHeader",
		"csvFilters",
		"processCsv",
		"csvUrl",
		"error"
	],
	components: {
		CsvExport
	},
	computed: {
		canConfirm: function () {
			return this.buttons.indexOf("confirm") > -1
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-menu";

.button {
	margin-top: auto;
	margin-bottom: auto;
	border-radius: 25px;
	background-color: #455a64;

	span,
	i {
		color: white;
	}

	font-family: "Montserrat", sans-serif;
}
</style>
